import React from "react";
import { Container } from "reactstrap";
import { Stack } from "react-bootstrap";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Tabs } from "antd";
import AirportReceptionList from "./AirportReceptionList";
import { RealEstate01FreeIcons } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Kaaba01Icon } from "@hugeicons/core-free-icons/index";

const ReceptionJeddah = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  // Get current source from URL, default to 'nusuk' if not present
  const defaultSource = "delegation";
  const currentSource = searchParams.get("source") || defaultSource;

  const handleTabChange = (key) => {
    setSearchParams({ source: key });
  };

  const tabItems = [
    {
      key: defaultSource,
      label: t("FROM_CAMPAIGN"),
      icon: <HugeiconsIcon size={14} icon={RealEstate01FreeIcons} />,
    },
    {
      key: "nusuk",
      label: t("FROM_NUSUK"),
      icon: <HugeiconsIcon size={14} icon={Kaaba01Icon} />,
    },
  ];

  return (
    <Stack gap={3}>
      <PageHeader title={t("RECEPTION_MAKKAH")} sticky={false} />
      <Container fluid>
        <Tabs
          activeKey={currentSource}
          items={tabItems}
          onChange={handleTabChange}
          className="mb-3"
        />
        <AirportReceptionList />
      </Container>
    </Stack>
  );
};

export default ReceptionJeddah;
